import React from 'react';
import { ArrowRight, CheckCircle2 } from 'lucide-react';
import { Link } from 'react-router-dom';
import Button from './Button';
import { motion } from 'framer-motion';

const Hero = () => {
  const trustMarkers = [
    'Zertifizierte Mitarbeiter',
    'DSGVO-konform',
    'Schnelle Verfügbarkeit',
    '24/7 Support'
  ];

  return (
    <section className="relative bg-white overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0 overflow-hidden">
        <img
          src="https://images.unsplash.com/photo-1497366216548-37526070297c?w=1600&q=80"
          alt="Professional business environment"
          className="w-full h-full object-cover"
          loading="eager"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-white/30 via-white/20 to-white/10"></div>
        <div className="absolute top-0 right-0 w-96 h-96 bg-primary-blue-light rounded-full blur-3xl opacity-20 transform translate-x-1/2 -translate-y-1/2"></div>
        <div className="absolute bottom-0 left-0 w-96 h-96 bg-primary-skin rounded-full blur-3xl opacity-30 transform -translate-x-1/2 translate-y-1/2"></div>
      </div>

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20 md:py-28 lg:py-36">
        <div className="max-w-4xl mx-auto">
          {/* Content */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            className="text-center backdrop-blur-md bg-white/40 rounded-3xl p-10 md:p-14 shadow-2xl border border-white/50"
          >
            {/* Eyebrow */}
            <div className="inline-block mb-6">
              <span className="inline-flex items-center px-4 py-2 rounded-full bg-primary-blue-light text-primary-blue-mid text-sm font-medium">
                Ihr Partner für professionelle Personallösungen
              </span>
            </div>

            {/* Main Headline */}
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-primary-text-dark mb-6 leading-tight">
              Verlässliche Personal‑ und Logistiklösungen
            </h1>

            {/* Subheadline */}
            <p className="text-lg md:text-xl text-gray-700 mb-8 leading-relaxed max-w-3xl mx-auto font-medium">
              SENKAY bietet schnelle, skalierbare und rechtssichere Personallösungen
              für München, Bayern und die DACH-Region. Von Gebäudemanagement bis
              Eventpersonal – wir sind Ihr One-Stop-Shop.
            </p>

            {/* CTA Buttons */}
            <div className="flex flex-col sm:flex-row gap-4 justify-center mb-10">
              <Link to="/kontakt">
                <Button variant="primary" size="lg" icon={ArrowRight} iconPosition="right">
                  Jetzt Angebot anfordern
                </Button>
              </Link>
              <Link to="/leistungen">
                <Button variant="secondary" size="lg">
                  Unsere Leistungen
                </Button>
              </Link>
            </div>

            {/* Trust Markers */}
            <div className="grid grid-cols-2 md:grid-cols-4 gap-4 max-w-3xl mx-auto">
              {trustMarkers.map((marker, index) => (
                <motion.div
                  key={index}
                  initial={{ opacity: 0, y: 10 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.4, delay: 0.2 + index * 0.1 }}
                  className="flex items-center justify-center space-x-2"
                >
                  <CheckCircle2 className="w-5 h-5 text-green-600 flex-shrink-0" />
                  <span className="text-sm text-gray-700 font-medium">{marker}</span>
                </motion.div>
              ))}
            </div>
          </motion.div>
        </div>
      </div>

      {/* Bottom Wave */}
      <div className="absolute bottom-0 left-0 right-0">
        <svg viewBox="0 0 1440 120" fill="none" xmlns="http://www.w3.org/2000/svg" className="w-full h-auto">
          <path
            d="M0 0L60 10C120 20 240 40 360 46.7C480 53 600 47 720 43.3C840 40 960 40 1080 46.7C1200 53 1320 67 1380 73.3L1440 80V120H1380C1320 120 1200 120 1080 120C960 120 840 120 720 120C600 120 480 120 360 120C240 120 120 120 60 120H0V0Z"
            fill="#F7EDE6"
            fillOpacity="0.3"
          />
        </svg>
      </div>
    </section>
  );
};

export default Hero;
